export function init () {
    const subnavElements = document.querySelectorAll('.js-subnav-expand');
    const subnavmobileElements = document.querySelectorAll('.js-subnavmobile');
    const loadMoreElements = document.querySelectorAll('.js-subnav-load-more');

    for(var i = 0; i < subnavElements.length; i++) {
        const item = subnavElements[i];
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const container = item.parentNode.querySelector('ul');

            item.classList.toggle('subnav__icon--open');
            container.classList.toggle('subnav__list--open');
        })
    }

    for(var i = 0; i < subnavmobileElements.length; i++) {
        const item = subnavmobileElements[i];
        item.addEventListener('click', function(e) {
            e.preventDefault();

            const container = item.parentNode.querySelector('.js-subnavmobile-container');
            container.classList.toggle('subnavmobile__list--open');
            item.classList.toggle('subnavmobile__icon--open');
        })
    }

    for(var i = 0; i < loadMoreElements.length; i++) {
        const item = loadMoreElements[i];
        item.addEventListener('click', function(e){
            e.preventDefault();

            const container = item.parentNode;
            container.classList.toggle('show-more');
            var loadMoreTexts = item.querySelectorAll('.js-subnav-load-more-text');
            for(var y = 0; y < loadMoreTexts.length; y++) {
                const loadMoreTextItem = loadMoreTexts[y];
                loadMoreTextItem.classList.toggle('active');
            }
        })
    }
}
